export type FlowActivityChannel = 'call' | 'sms' | 'email';

export const FLOW_ACTIVITY_CHANNELS: FlowActivityChannel[] = ['call', 'sms', 'email'];

/** Channels the Activity table queries: the filter's picks, or every channel the org can use. */
export function activeFlowActivityChannels(
  filters: FlowActivityChannel[],
  flywheelEnabled: boolean
): FlowActivityChannel[] {
  const allowed = flywheelEnabled
    ? FLOW_ACTIVITY_CHANNELS
    : FLOW_ACTIVITY_CHANNELS.filter((c) => c !== 'sms');
  const picked = filters.filter((c) => allowed.includes(c));
  return picked.length > 0 ? picked : allowed;
}
